import { Locale, type LocalizedString } from "../Locale.js";

export const categorySearchParamLocalized: LocalizedString = {
	[Locale.cs]: "kategorie",
};
